import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import {connect} from 'react-redux';
import {replacePlaceholders} from '../../../../utilities/StringHelpers/TitleHelpers';
import {setShowPopUp} from '../BusinessWorkOrderSystemSlice';

const GeneralMessagePopup = (props) => {
  const popupData = props.businessWorkOrderSystem.currentPopupData;
  const popupActions = {
    setShowPopUp: () => props.setShowPopUp(false),
  };

  return (
    <div className='business-work-order-system-general-message-page'>
      <Image src={popupData.icon} />
      <p
        className='l-title'
        dangerouslySetInnerHTML={{__html: replacePlaceholders(popupData.title, props.businessWorkOrderSystem, isMobile)}}
      />
      {popupData.secondTitle && (
        <p
          className='m-title'
          dangerouslySetInnerHTML={{__html: replacePlaceholders(popupData.secondTitle, props.businessWorkOrderSystem, isMobile)}}
        />
      )}
      {popupData.subTitle && (
        <p
          className='m-title'
          dangerouslySetInnerHTML={{__html: replacePlaceholders(popupData.subTitle, props.businessWorkOrderSystem, isMobile)}}
        />
      )}
      <div className='continue-button'>
        {popupData.buttonText && <BtnSubmit text={popupData.buttonText} onclick={popupActions[popupData.buttonClick]} />}
        {popupData.secondButtonText && (
          <BtnWhiteBlackBorderBigSize
            className={`second-button`}
            text={popupData.secondButtonText}
            onclick={popupActions[popupData.secondButtonClick]}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});

const mapDispatchToProps = {setShowPopUp};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessagePopup);
